import type {
  LoginCredentials,
  MfaChallengeResponse,
  MfaResendResponse,
  User,
} from "@/types/auth";
import { apiClient } from "./client";

export const authApi = {
  login(credentials: LoginCredentials): Promise<User | MfaChallengeResponse> {
    return apiClient.post<User | MfaChallengeResponse>(
      "/auth/login",
      credentials,
    );
  },

  mfaVerify(
    mfaToken: string,
    code: string,
    rememberDevice: boolean,
  ): Promise<User> {
    return apiClient.post<User>("/auth/mfa/verify", {
      mfaToken,
      code,
      rememberDevice,
    });
  },

  mfaResend(mfaToken: string): Promise<MfaResendResponse> {
    return apiClient.post<MfaResendResponse>("/auth/mfa/resend", {
      mfaToken,
    });
  },

  me(): Promise<User> {
    return apiClient.get<User>("/auth/me");
  },

  logout(): Promise<void> {
    return apiClient.post<void>("/auth/logout");
  },

  refresh(): Promise<{ expiresAt: string }> {
    return apiClient.post<{ expiresAt: string }>("/auth/refresh");
  },

  csrf(): Promise<void> {
    return apiClient.get<void>("/auth/csrf");
  },

  forgotPassword(email: string): Promise<void> {
    return apiClient.post<void>("/auth/forgot-password", { email });
  },

  resetPassword(
    email: string,
    token: string,
    newPassword: string,
  ): Promise<void> {
    return apiClient.post<void>("/auth/reset-password", {
      email,
      token,
      newPassword,
    });
  },
};
